import generate from 'nanoid/generate';
import BaseComponent from 'foundation/base-component';

class DfpBanner extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        const parseSize = (size) => {
            if (!size || size.length === 0) return [];
            const cleaned = size.toString().replace(/[\[\]]/g, '');
            return cleaned.split(',').map(Number);
        };

        const desktopSize = parseSize(this.options.adUnitDesktopSize);
        const mobileSize = parseSize(this.options.adUnitMobileSize);
        this.targetId = generate('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 10);
        this.element.id = this.targetId;

        window.googletag = window.googletag || {};
        window.gptAdSlots = [];
        window.googletag.cmd = window.googletag.cmd || [];
        window.googletag.cmd.push(() => {
            const bottomAdSizes = window.googletag.sizeMapping()
                .addSize([768, 0], desktopSize)
                .addSize([0, 0], mobileSize)
                .build();

            window.gptAdSlots[0] = window.googletag
                .defineSlot(
                    this.options.slot, [
                        mobileSize,
                        desktopSize
                    ],
                    this.targetId
                );

            if (window.gptAdSlots[0]) {
                window.gptAdSlots[0].defineSizeMapping(bottomAdSizes)
                    .addService(window.googletag.pubads());
            }

            window.googletag.pubads().enableSingleRequest();
            window.googletag.companionAds().setRefreshUnfilledSlots(true);
            window.googletag.pubads().enableVideoAds();
            window.googletag.enableServices();

            setInterval(() => {
                window.googletag.pubads().refresh();
            }, this.options.refreshRate);
        });

        window.googletag.cmd.push(() => {
            window.googletag.display(this.targetId);
        });

        this.loadScipt();
    }

    loadScipt() {
        if (window.googletag && window.googletag.apiReady) return;

        const script = document.createElement('script');
        script.src = '//www.googletagservices.com/tag/js/gpt.js';
        script.async = true;
        document.body.appendChild(script);
    }
}

export default DfpBanner;
